import { render, staticRenderFns } from "./detail.vue?vue&type=template&id=1420cfbd&scoped=true&"
import script from "./detail.vue?vue&type=script&lang=js&"
export * from "./detail.vue?vue&type=script&lang=js&"
import style0 from "./detail.vue?vue&type=style&index=0&id=1420cfbd&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1420cfbd",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\project\\uniFrame\\uni-frame\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1420cfbd')) {
      api.createRecord('1420cfbd', component.options)
    } else {
      api.reload('1420cfbd', component.options)
    }
    module.hot.accept("./detail.vue?vue&type=template&id=1420cfbd&scoped=true&", function () {
      api.rerender('1420cfbd', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/cate/detail.vue"
export default component.exports